import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

import {
  NEWRELIC_ENABLED,
  NEWRELIC_LICENSE_KEY,
  NEWRELIC_APPLICATION_ID,
  NEWRELIC_ACCOUNT_ID,
} from 'global';

export const setupNewRelic = () => {
  if (1 !== Number(NEWRELIC_ENABLED)) {
    return;
  }

  new BrowserAgent({
    init: {
      distributed_tracing: {
        enabled: true,
      },
      privacy: {
        cookies_enabled: true,
      },
      ajax: {
        deny_list: ['bam.nr-data.net'],
      },
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: NEWRELIC_LICENSE_KEY,
      applicationID: NEWRELIC_APPLICATION_ID,
      sa: 1,
    },
    loader_config: {
      accountID: NEWRELIC_ACCOUNT_ID,
      trustKey: NEWRELIC_ACCOUNT_ID,
      agentID: NEWRELIC_APPLICATION_ID,
      licenseKey: NEWRELIC_LICENSE_KEY,
      applicationID: NEWRELIC_APPLICATION_ID,
    },
  });
};
